import SettingsPage from 'components/features/pfm/SettingsPage/SettingsPage'
import internal from 'components/utils/Internal'

const SettingsPageContainer = internal(SettingsPage)

export default SettingsPageContainer
